import React from 'react';
import '../styling/Tip.css';

export default function BrightnessTip({ text, right, bottom, top, left, visibility, onClose }) {
  if (!visibility) return null;

  return (
    <div
      className="brightness-tip"
      style={{
        bottom: bottom + "px",
        right: right + "px",
        top: top ? top + "px" : undefined,
        left: left ? left + "px" : undefined,
      }}
    >
      {text}
      <span className="close-btn" onClick={onClose}>
        &times;
      </span>
    </div>
  );
}
